// UI strings for "Päätteet | Kokonaiset muodot" of the Kielioppi declension tables (grammar/endings.ts,
// FormGrid): the stem written once, the endings alone in the cells. Finnish first; en has the same shape.
import { defineArea } from '../area';

export const grammarEndingsFi = {
  /** The segmented control's name (for screen readers): what the table shows. */
  label: 'Taulukon muodot',
  /** Its two choices: the stem once and the endings alone, or every form whole. */
  ends: 'Päätteet',
  full: 'Kokonaiset muodot',
  /** Before the stem written once above a one-word table. */
  stem: 'Vartalo',
};

export const grammarEndingsEn: typeof grammarEndingsFi = {
  label: 'Forms in the table',
  ends: 'Endings',
  full: 'Full forms',
  stem: 'Stem',
};

// Messages.grammarEndings (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('grammarEndings', grammarEndingsFi, grammarEndingsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof grammarEndingsFi> {}
}
